export const INVENTORY_MOCK = {
  status: 200,
  body: {
    status: 200,
    msg: 'Inventory',
    data: {
      dailySpinner: null,
      roundSpinner: null,
      bounty: null,
    },
  },
};
